import { ASSET_TYPE } from "@/features/campaigns/direct-mail/rrd/utils/rrdConstants";
import type { RRDLayoutSpec } from "./layoutTypes";

export function slotsByType(layoutSpec: RRDLayoutSpec, assetType: string) {
  return (layoutSpec.slots || []).filter(
    (slot) => slot.assetType === assetType
  );
}

export function couponSlots(
  layoutSpec: RRDLayoutSpec,
  side?: string,
  editable?: boolean
) {
  return (layoutSpec.slots || []).filter(
    (slot) =>
      slot.assetType === ASSET_TYPE.COUPON &&
      (!side || slot.side === side) &&
      (editable === undefined || (slot.editable !== false) === editable)
  );
}

export function fixedSlot(layoutSpec: RRDLayoutSpec) {
  return (layoutSpec.slots || []).find(
    (slot) => slot.assetType === ASSET_TYPE.FIXED_IMAGE
  );
}
